import { useLazyComment, useSwitchGetCommentScope } from "@/hooks/useComment";
import { CommentScope } from "@/interfaces/comment.interface";
import { List } from "antd";
import MyComment from "./MyComment";

interface IProps {
  fatherId: string;
  scope: CommentScope;
}

const MyLazyCommentList: React.FC<IProps> = ({ fatherId, scope }) => {
  const { page, size, setPageSize, loading } = useLazyComment(fatherId, scope);
  const comments = useSwitchGetCommentScope(scope, fatherId);

  return (
    <List
      dataSource={comments?.results ?? []}
      loading={loading}
      itemLayout="horizontal"
      renderItem={(props) => (
        <MyComment comment={props} fatherId={fatherId} scope={scope} />
      )}
      pagination={{
        total: comments?.count || 0,
        pageSize: size,
        current: page,
        onChange: (page, size) => setPageSize({ page, size }),
        showSizeChanger: true,
        hideOnSinglePage: true,
        pageSizeOptions: ["5", "10", "20", "30", "50"],
      }}
      split
    />
  );
};

export default MyLazyCommentList;
